<div class="navbar" id="tabs">
    <a i18n routerLink="/dashboard/home" routerLinkActive="router-link-active" >
        <mat-icon>home</mat-icon>
    </a>
    <a i18n routerLink="/dashboard/selection" routerLinkActive="router-link-active">
        <mat-icon>gavel</mat-icon>
    </a>

    <a i18n routerLink="/dashboard/designs" routerLinkActive="router-link-active">
        <mat-icon>palette</mat-icon>
    </a>
    <a i18n routerLink="/dashboard/orders" routerLinkActive="router-link-active">
        <mat-icon>calendar_today</mat-icon>
    </a>
    <a i18n href="#">
        <mat-icon>help_outline</mat-icon>
    </a>
</div> 
